import React from 'react'
import "./Getstarted.css"


const Getstarted = ({refProp}) => {
  return (
    <>
     <section ref={refProp}> 
    <div className="g-wrapper">
    <div className="g-container">
        <div className="inner-container">
            <span className='secondary'>Get started with Real Estate</span>
            <span className='prim'>Subscribe and find more porperties <br />

            </span>
            <button className="button">
                <a href="mailto:shwetanglfh@gmail.com">Get started</a>
            </button>
        </div>


    </div>


    </div>

      </section>
    </>
  )
};

export default Getstarted
